import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FiltroBusquedaPipe, NoImagenPipe, safeUrlPipe, OrdenarPipe, ExpedientePorcentajePipe, OrdenarFechaPipe } from './pipes'
import { OnlyNumber } from './directives';
import { FiltroBusquedaGenericoPipe } from './pipes/busqueda-filtro-generico.pipe';
import { MayusculaEspaciosPipe } from './pipes/mayuscula-espacios.pipe';
import { NombrePorIdCatalogoPipe } from './pipes/nombre-por-id-catalogo.pipe';
import { MayusculaEspaciosRepsePipe } from './pipes/mayusculas-repse.pipe';
import { LigarArregloPipe } from './pipes/ligar-arreglo.pipe';
import { FormatStringPipe } from './pipes/transformaTituloRepse.pipe';
import { StatusColorDirective } from './directives/status-color.directive';
import { BackButtonComponent } from './components/back-button/backbutton';
import {MatIconModule} from '@angular/material/icon';
import { StatusBoleanDirective } from './directives/statusBolean.directive';
import { CapitalizeExceptPipe } from './pipes/mayusculasNoArticulos';
import { OrderByPipe } from './pipes/order-by.pipe';
import { ObjectToStringPipe } from './pipes/objectToString';
import { BitacoraPaginasComponent } from '../paginas/@components/bitacora-paginas/bitacora-paginas.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';

const BASE_MODULES = [
  FormsModule,
  ReactiveFormsModule,
  CommonModule,
  MatIconModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatDatepickerModule,
  MatInputModule,
  MatButtonModule,
  MatTableModule,
  MatPaginatorModule,
  MatSelectModule
];

const PIPES = [
  NoImagenPipe,
  safeUrlPipe,
  FiltroBusquedaPipe,
  FiltroBusquedaGenericoPipe,
  NombrePorIdCatalogoPipe,
  MayusculaEspaciosPipe,
  OrdenarPipe,
  ExpedientePorcentajePipe,
  OrdenarFechaPipe,
  MayusculaEspaciosRepsePipe,
  LigarArregloPipe,
  FormatStringPipe,
  CapitalizeExceptPipe,
  OrderByPipe,
  ObjectToStringPipe
];

const DIRECTIVES = [
  OnlyNumber,
  StatusColorDirective,
  StatusBoleanDirective
];

const COMPONENTS = [
  BackButtonComponent,
  BitacoraPaginasComponent  
];

@NgModule({
  declarations: [...PIPES, ...DIRECTIVES, ...COMPONENTS],
  imports: [...BASE_MODULES],
  exports: [...BASE_MODULES, ...PIPES, ...DIRECTIVES,...COMPONENTS]
})
export class CompartidoModule { }
